<template>
  <div>
    <aside class="mdc-drawer mobilehide mdc-drawer--modal">
      <div class="drawer-wrapper">
        <div class="mdc-drawer__header mgt-24">
          <div class="d-flex pdl-8 align-items-center justify-content-between">
            <div class="position-relative cursor-pointer">
              <UserImgProfile v-if="memberDetail" :data="memberDetail" :className="'mgr-0'" :size="'l'" />
              <div
                class="profile-setting-icon b-radius50 bg-white w-32 h-32 d-flex align-items-center justify-content-center"
              >
                <button
                  class="material-icons t-color-iconInactive w-30 h-30 b-radius50 line-h-22 d-flex align-items-center justify-content-center"
                  tabindex="0"
                  @click="openPattenDialog"
                  @keypress="openPattenDialog"
                >
                  <img
                    alt=""
                    class="circle w-30 h-30"
                    src="/images/myinformation/info-setting.png"
                    tabindex="0"
                  />
                </button>
              </div>
            </div>

            <!-- <i class="material-icons setting">inbox</i> -->
          </div>

          <div class="mgt-24 t-subtitle3 font-m pdl-8">
            {{
              firstName || lastName
                ? $t("3437", { first: firstName, last: lastName })
                : ""
            }}
          </div>
          <div class="d-flex mgt-8 pdl-8 align-items-baseline">
            <div class="t-body2 t-color-bodyGrayA font-m pdr-11">
              {{ memberDetail ? memberDetail.dutyName : "" }}
            </div>
            <div class="t-body2 t-color-bodyGrayA font-m">
              {{ memberDetail ? memberDetail.responsibilityName : "" }}
            </div>
          </div>
        </div>
        <div class="divider mgt-12"></div>
        <div class="mdc-drawer__content">
          <nav class="mdc-list mgb-50">
            <div class="nav-group">
              <div class="pdt-4 pdb-4">
                <div
                  :class="
                    routeName[0] === 'leader' ? 'mdc-list-item--activated' : ''
                  "
                  class="mdc-list-item"
                >
                  <router-link tabindex="0" to="/leader?status=RANKING">
                    <span class="mdc-list-item__ripple"></span>
                    <i
                      class="material-icons mdc-list-item__graphic mgl-16 mgr-36 rtl-support font-22"
                      >equalizer</i
                    >
                    <span
                      class="mdc-list-item__text t-body2 font-m t-color-bodyGrayA"
                    >
                      {{ $t("2000") }}
                    </span>
                  </router-link>
                  <button
                    class="material-icons mgl-auto mgr-16 t-color-bodyGrayA content-trigger pdx-0"
                    tabindex="0"
                    @click="submenuToggle($event)"
                  >
                    keyboard_arrow_down
                  </button>
                </div>
                <div
                  :class="routeName[0] === 'leader' ? '' : 'd-none'"
                  class="navDrawerSubmenu"
                >
                  <div class="pdt-4 pdb-4">
                    <router-link tabindex="0" to="/leader?status=RANKING">
                      <div class="mdc-list-item pdl-50">
                        <span class="mdc-list-item__ripple"></span>
                        <span
                          class="mdc-list-item__text t-body2 font-m t-color-bodyGrayA t-color-bodyGrayA pdl-24"
                          >{{ $t("2001") }}</span
                        >
                      </div>
                    </router-link>
                  </div>
                  <div class="pdt-4 pdb-4">
                    <router-link tabindex="0" to="/leader?status=STORE">
                      <div class="mdc-list-item pdl-50">
                        <span class="mdc-list-item__ripple"></span>
                        <span
                          class="mdc-list-item__text t-body2 font-m t-color-bodyGrayA t-color-bodyGrayA pdl-24"
                          >{{ $t("2002") }}</span
                        >
                      </div>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
            <div v-show="isSkillPath">
              <div class="divider mgt-8"></div>
              <!-- MICRO DEGREE START -->
              <div class="nav-group">
                <div class="pdt-4 pdb-4">
                  <div
                    :class="
                      routeName[0] === 'micro-course'
                        ? 'mdc-list-item--activated'
                        : ''
                    "
                    class="mdc-list-item"
                  >
                    <router-link tabindex="0" to="/micro-course">
                      <span class="mdc-list-item__ripple"></span>
                      <i
                        class="material-icons mdc-list-item__graphic mgl-16 mgr-36 rtl-support font-22"
                        >insights</i
                      >
                      <span
                        class="mdc-list-item__text t-body2 font-m t-color-bodyGrayA"
                        >{{ $t("30092") }}</span
                      >
                    </router-link>
                    <!--                <button class="material-icons mgl-auto mgr-16 t-color-bodyGrayA content-trigger pdx-0" tabindex="0" @click="submenuToggle($event)">keyboard_arrow_down</button>-->
                  </div>
                </div>
                <div class="pdt-4 pdb-4">
                  <div
                    :class="
                      routeName[0] === 'micro' ? 'mdc-list-item--activated' : ''
                    "
                    aria-current="page"
                    class="mdc-list-item"
                  >
                    <router-link tabindex="0" to="/micro?status=LEARNING">
                      <span class="mdc-list-item__ripple"></span>
                      <i
                        aria-hidden="true"
                        class="material-icons mdc-list-item__graphic mgl-16 mgr-36 rtl-support font-22"
                        >auto_stories</i
                      >
                      <span
                        class="mdc-list-item__text t-body2 font-m t-color-bodyGrayA"
                        >{{ $t("30091") }}</span
                      >
                    </router-link>
                    <button
                      aria-hidden="true"
                      class="material-icons mgl-auto mgr-16 t-color-bodyGrayA content-trigger pdx-0"
                      tabindex="0"
                      @click="submenuToggle($event)"
                    >
                      keyboard_arrow_down
                    </button>
                  </div>
                  <!-- LEARN WAITING COMPLETED -->
                  <div
                    :class="isMicroView ? '' : 'd-none'"
                    class="navDrawerSubmenu"
                  >
                    <div class="pdt-4 pdb-4">
                      <router-link
                        :class="
                          isMicro && routeQuery.status === 'LEARNING'
                            ? 'router-link-exact-active '
                            : ''
                        "
                        tabindex="0"
                        to="/micro?status=LEARNING"
                      >
                        <div class="mdc-list-item pdl-50">
                          <span class="mdc-list-item__ripple"></span>
                          <span
                            class="mdc-list-item__text t-body2 font-m t-color-bodyGrayA t-color-bodyGrayA pdl-24"
                            >{{ $t("30219") }}
                          </span>
                        </div>
                      </router-link>
                    </div>
                    <div class="pdt-4 pdb-4">
                      <router-link
                        :class="
                          isMicro && routeQuery.status === 'WAITING'
                            ? 'router-link-exact-active '
                            : ''
                        "
                        tabindex="0"
                        to="/micro?status=WAITING"
                      >
                        <div class="mdc-list-item pdl-50">
                          <span class="mdc-list-item__ripple"></span>
                          <span
                            class="mdc-list-item__text t-body2 font-m t-color-bodyGrayA t-color-bodyGrayA pdl-24"
                            >{{ $t("30220") }}
                          </span>
                        </div>
                      </router-link>
                    </div>
                    <div class="pdt-4 pdb-4">
                      <router-link
                        :class="
                          isMicro && routeQuery.status === 'COMPLETION'
                            ? 'router-link-exact-active '
                            : ''
                        "
                        tabindex="0"
                        to="/micro?status=COMPLETION"
                      >
                        <div class="mdc-list-item pdl-50">
                          <span class="mdc-list-item__ripple"></span>
                          <span
                            class="mdc-list-item__text t-body2 font-m t-color-bodyGrayA t-color-bodyGrayA pdl-24"
                            >{{ $t("30221") }}</span
                          >
                        </div>
                      </router-link>
                    </div>
                  </div>
                  <!-- LEARN WAITING COMPLETED -->
                </div>
              </div>
            </div>
            <!-- MICRO DEGREE END -->

            <div class="divider mgt-8"></div>

            <div class="nav-group">
              <div id="" class="pdt-4 pdb-4">
                <div
                  :class="
                    routeName[0] == 'degree' ? 'mdc-list-item--activated' : ''
                  "
                  aria-current="page"
                  class="mdc-list-item"
                >
                  <router-link tabindex="0" to="/degree?type=ListTotal">
                    <span class="mdc-list-item__ripple"></span>
                    <i
                      aria-hidden="true"
                      class="material-icons mdc-list-item__graphic mgl-16 mgr-36 rtl-support font-22"
                      >play_circle</i
                    >
                    <span
                      class="mdc-list-item__text t-body2 font-m t-color-bodyGrayA"
                      >{{ $t("2014") }}</span
                    >
                  </router-link>
                  <button
                    aria-hidden="true"
                    class="material-icons mgl-auto mgr-16 t-color-bodyGrayA content-trigger pdx-0"
                    tabindex="0"
                    @click="submenuToggle($event)"
                  >
                    keyboard_arrow_down
                  </button>
                </div>

                <div
                  :class="routeName[0] === 'degree' ? '' : 'd-none'"
                  class="navDrawerSubmenu"
                >
                  <div class="pdt-4 pdb-4">
                    <router-link
                      :class="
                        routeQuery.type == 'ListTotal' ||
                        routeQuery.type == 'ListCategory'
                          ? 'router-link-exact-active'
                          : ''
                      "
                      class=""
                      tabindex="0"
                      to="/degree?type=ListTotal"
                    >
                      <div class="mdc-list-item pdl-50">
                        <span class="mdc-list-item__ripple"></span>
                        <span
                          class="mdc-list-item__text t-body2 font-m t-color-bodyGrayA t-color-bodyGrayA pdl-24"
                          >{{ $t("2015") }}</span
                        >
                      </div>
                    </router-link>
                  </div>
                  <div class="pdt-4 pdb-4">
                    <router-link
                      :class="
                        routeQuery.type == 'ListPopular'
                          ? 'router-link-exact-active'
                          : ''
                      "
                      class=""
                      tabindex="0"
                      to="/degree?type=ListPopular"
                    >
                      <div class="mdc-list-item pdl-50">
                        <span class="mdc-list-item__ripple"></span>
                        <span
                          class="mdc-list-item__text t-body2 font-m t-color-bodyGrayA t-color-bodyGrayA pdl-24"
                          >{{ $t("2016") }}</span
                        >
                      </div>
                    </router-link>
                  </div>
                  <div class="pdt-4 pdb-4">
                    <router-link
                      :class="
                        routeQuery.type == 'ListNew'
                          ? 'router-link-exact-active'
                          : ''
                      "
                      class=""
                      tabindex="0"
                      to="/degree?type=ListNew"
                    >
                      <div class="mdc-list-item pdl-50">
                        <span class="mdc-list-item__ripple"></span>
                        <span
                          class="mdc-list-item__text t-body2 font-m t-color-bodyGrayA t-color-bodyGrayA pdl-24"
                          >{{ $t("2017") }}</span
                        >
                      </div>
                    </router-link>
                  </div>
                  <div class="pdt-4 pdb-4">
                    <router-link
                      :class="
                        routeQuery.type == 'ListRecommened'
                          ? 'router-link-exact-active'
                          : ''
                      "
                      class=""
                      tabindex="0"
                      to="/degree?type=ListRecommened"
                    >
                      <div class="mdc-list-item pdl-50">
                        <span class="mdc-list-item__ripple"></span>
                        <span
                          class="mdc-list-item__text t-body2 font-m t-color-bodyGrayA t-color-bodyGrayA pdl-24"
                          >{{ $t("2018") }}</span
                        >
                      </div>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
            <div class="nav-group">
              <div class="pdt-4 pdb-4">
                <div
                  :class="isLearnView ? 'mdc-list-item--activated' : ''"
                  aria-current="page"
                  class="mdc-list-item"
                >
                  <router-link tabindex="0" to="/learn?status=LEARNING">
                    <span class="mdc-list-item__ripple"></span>
                    <i
                      aria-hidden="true"
                      class="material-icons mdc-list-item__graphic mgl-16 mgr-36 rtl-support font-22"
                      >subscriptions</i
                    >

                    <span
                      class="mdc-list-item__text t-body2 font-m t-color-bodyGrayA"
                      >{{ $t("2003") }}</span
                    >
                  </router-link>
                  <button
                    aria-hidden="true"
                    class="material-icons mgl-auto mgr-16 t-color-bodyGrayA content-trigger pdx-0"
                    tabindex="0"
                    @click="submenuToggle($event)"
                  >
                    keyboard_arrow_down
                  </button>
                </div>
                <div
                  :class="routeName[0] === 'learn' ? '' : 'd-none'"
                  class="navDrawerSubmenu"
                >
                  <div class="pdt-4 pdb-4">
                    <router-link
                      :class="
                        !isMicro && routeQuery.status === 'LEARNING'
                          ? 'router-link-exact-active '
                          : ''
                      "
                      tabindex="0"
                      to="/learn?status=LEARNING"
                    >
                      <div class="mdc-list-item pdl-50">
                        <span class="mdc-list-item__ripple"></span>
                        <span
                          class="mdc-list-item__text t-body2 font-m t-color-bodyGrayA t-color-bodyGrayA pdl-24"
                          >{{ $t("2004") }}
                        </span>
                      </div>
                    </router-link>
                  </div>
                  <div class="pdt-4 pdb-4">
                    <router-link
                      :class="
                        !isMicro && routeQuery.status === 'WAITING'
                          ? 'router-link-exact-active '
                          : ''
                      "
                      tabindex="0"
                      to="/learn?status=WAITING"
                    >
                      <div class="mdc-list-item pdl-50">
                        <span class="mdc-list-item__ripple"></span>
                        <span
                          class="mdc-list-item__text t-body2 font-m t-color-bodyGrayA t-color-bodyGrayA pdl-24"
                          >{{ $t("2005") }}
                        </span>
                      </div>
                    </router-link>
                  </div>
                  <div class="pdt-4 pdb-4">
                    <router-link
                      :class="
                        !isMicro && routeQuery.status === 'COMPLETION'
                          ? 'router-link-exact-active '
                          : ''
                      "
                      tabindex="0"
                      to="/learn?status=COMPLETION"
                    >
                      <div class="mdc-list-item pdl-50">
                        <span class="mdc-list-item__ripple"></span>
                        <span
                          class="mdc-list-item__text t-body2 font-m t-color-bodyGrayA t-color-bodyGrayA pdl-24"
                          >{{ $t("2006") }}</span
                        >
                      </div>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>

            <div class="divider mgt-8"></div>

            <div class="nav-group">
              <div class="pdt-4 pdb-4">
                <div
                  :class="
                    routeName.length > 1 &&
                    routeName[0] == 'independent' &&
                    routeName[1] == 'exam'
                      ? 'mdc-list-item--activated'
                      : ''
                  "
                  class="mdc-list-item"
                >
                  <router-link
                    tabindex="0"
                    to="/independent/exam?listType=total"
                  >
                    <span class="mdc-list-item__ripple"></span>
                    <i
                      class="material-icons mdc-list-item__graphic mgl-16 mgr-36 rtl-support font-22"
                      >done_all</i
                    >
                    <span
                      class="mdc-list-item__text t-body2 font-m t-color-bodyGrayA"
                      >{{ $t("2022") }}</span
                    >
                  </router-link>
                  <button
                    class="material-icons mgl-auto mgr-16 t-color-bodyGrayA content-trigger pdx-0"
                    tabindex="0"
                    @click="submenuToggle($event)"
                  >
                    keyboard_arrow_down
                  </button>
                </div>
                <div
                  :class="
                    routeName.length > 1 &&
                    routeName[0] == 'independent' &&
                    routeName[1] == 'exam'
                      ? ''
                      : 'd-none'
                  "
                  class="navDrawerSubmenu"
                >
                  <div class="pdt-4 pdb-4">
                    <router-link
                      :class="
                        (routeName.length > 1 &&
                          routeName[1] == 'exam' &&
                          routeQuery.listType == 'total') ||
                        (routeName[1] == 'exam' &&
                          routeQuery.listType == 'category')
                          ? 'router-link-exact-active'
                          : ''
                      "
                      tabindex="0"
                      to="/independent/exam?listType=total"
                    >
                      <div class="mdc-list-item pdl-50">
                        <span class="mdc-list-item__ripple"></span>
                        <span
                          class="mdc-list-item__text t-body2 font-m t-color-bodyGrayA t-color-bodyGrayA pdl-24"
                          >{{ $t("2024") }}</span
                        >
                      </div>
                    </router-link>
                  </div>
                  <div class="pdt-4 pdb-4">
                    <router-link
                      :class="
                        routeName.length > 1 &&
                        routeName[1] == 'exam' &&
                        routeQuery.listType == 'my'
                          ? 'router-link-exact-active'
                          : ''
                      "
                      tabindex="0"
                      to="/independent/exam?listType=my"
                    >
                      <div class="mdc-list-item pdl-50">
                        <span class="mdc-list-item__ripple"></span>
                        <span
                          class="mdc-list-item__text t-body2 font-m t-color-bodyGrayA t-color-bodyGrayA pdl-24"
                          >{{ $t("2023") }}</span
                        >
                      </div>
                    </router-link>
                  </div>
                  <div class="pdt-4 pdb-4">
                    <router-link
                      :class="
                        routeName.length > 1 &&
                        routeName[1] == 'exam' &&
                        routeQuery.listType == 'result'
                          ? 'router-link-exact-active'
                          : ''
                      "
                      tabindex="0"
                      to="/independent/exam?listType=result"
                    >
                      <div class="mdc-list-item pdl-50">
                        <span class="mdc-list-item__ripple"></span>
                        <span
                          class="mdc-list-item__text t-body2 font-m t-color-bodyGrayA t-color-bodyGrayA pdl-24"
                          >{{ $t("2025") }}</span
                        >
                      </div>
                    </router-link>
                  </div>
                </div>
              </div>

              <div class="pdt-4 pdb-4">
                <div
                  :class="
                    routeName.length > 1 &&
                    routeName[0] == 'independent' &&
                    routeName[1] == 'survey'
                      ? 'mdc-list-item--activated'
                      : ''
                  "
                  class="mdc-list-item"
                >
                  <router-link
                    tabindex="0"
                    to="/independent/survey?listType=total"
                  >
                    <span class="mdc-list-item__ripple"></span>
                    <i
                      class="material-icons mdc-list-item__graphic mgl-16 mgr-36 rtl-support font-22"
                      >pie_chart</i
                    >
                    <span
                      class="mdc-list-item__text t-body2 font-m t-color-bodyGrayA"
                      >{{ $t("2026") }}</span
                    >
                  </router-link>
                  <button
                    class="material-icons mgl-auto mgr-16 t-color-bodyGrayA content-trigger pdx-0"
                    tabindex="0"
                    @click="submenuToggle($event)"
                  >
                    keyboard_arrow_down
                  </button>
                </div>

                <div
                  :class="
                    routeName.length > 1 &&
                    routeName[0] == 'independent' &&
                    routeName[1] == 'survey'
                      ? ''
                      : 'd-none'
                  "
                  class="navDrawerSubmenu"
                >
                  <div class="pdt-4 pdb-4">
                    <router-link
                      :class="
                        (routeName.length > 1 &&
                          routeName[1] == 'survey' &&
                          routeQuery.listType == 'total') ||
                        (routeName[1] == 'survey' &&
                          routeQuery.listType == 'category')
                          ? 'router-link-exact-active dk'
                          : ''
                      "
                      tabindex="0"
                      to="/independent/survey?listType=total"
                    >
                      <div class="mdc-list-item pdl-50">
                        <span class="mdc-list-item__ripple"></span>
                        <span
                          class="mdc-list-item__text t-body2 font-m t-color-bodyGrayA t-color-bodyGrayA pdl-24"
                          >{{ $t("2027") }}</span
                        >
                      </div>
                    </router-link>
                  </div>
                  <div class="pdt-4 pdb-4">
                    <router-link
                      :class="
                        routeName.length > 1 &&
                        routeName[1] == 'survey' &&
                        routeQuery.listType == 'my'
                          ? 'router-link-exact-active'
                          : ''
                      "
                      tabindex="0"
                      to="/independent/survey?listType=my"
                    >
                      <div class="mdc-list-item pdl-50">
                        <span class="mdc-list-item__ripple"></span>
                        <span
                          class="mdc-list-item__text t-body2 font-m t-color-bodyGrayA t-color-bodyGrayA pdl-24"
                          >{{ $t("2028") }}</span
                        >
                      </div>
                    </router-link>
                  </div>
                  <div class="pdt-4 pdb-4">
                    <router-link
                      :class="
                        routeName.length > 1 &&
                        routeName[1] == 'survey' &&
                        routeQuery.listType == 'result'
                          ? 'router-link-exact-active'
                          : ''
                      "
                      tabindex="0"
                      to="/independent/survey?listType=result"
                    >
                      <div class="mdc-list-item pdl-50">
                        <span class="mdc-list-item__ripple"></span>
                        <span
                          class="mdc-list-item__text t-body2 font-m t-color-bodyGrayA t-color-bodyGrayA pdl-24"
                          >{{ $t("2029") }}</span
                        >
                      </div>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>

            <div class="divider mgt-8"></div>

            <div class="nav-group">
              <div class="pdt-4 pdb-4">
                <div
                  :class="
                    routeName[0] === 'point' ||
                    routeName[0] === 'level' ||
                    routeName[0] === 'rewardcertificatelist' ||
                    routeName[0] === 'badgedetail' ||
                    routeName[0] === 'certificatedetail' ||
                    routeName[0] === 'rewardbadgelist'
                      ? 'mdc-list-item--activated'
                      : ''
                  "
                  class="mdc-list-item"
                >
                  <router-link tabindex="0" to="/point">
                    <span class="mdc-list-item__ripple"></span>
                    <i
                      class="material-icons mdc-list-item__graphic mgl-16 mgr-36 rtl-support font-22"
                      >grade</i
                    >
                    <span
                      class="mdc-list-item__text t-body2 font-m t-color-bodyGrayA"
                      >{{ $t("2011") }}</span
                    >
                  </router-link>
                  <button
                    class="material-icons mgl-auto mgr-16 t-color-bodyGrayA content-trigger pdx-0"
                    tabindex="0"
                    @click="submenuToggle($event)"
                  >
                    keyboard_arrow_down
                  </button>
                </div>

                <div
                  :class="
                    routeName[0] === 'point' ||
                    routeName[0] === 'rewardcertificatelist' ||
                    routeName[0] === 'badgedetail' ||
                    routeName[0] === 'certificatedetail' ||
                    routeName[0] === 'rewardbadgelist' ||
                    routeName[0] === 'level'
                      ? ''
                      : 'd-none'
                  "
                  class="navDrawerSubmenu"
                >
                  <div class="pdt-4 pdb-4">
                    <router-link
                      :class="
                        routeName[0] === 'point'
                          ? 'router-link-exact-active'
                          : ''
                      "
                      tabindex="0"
                      to="/point"
                    >
                      <div class="mdc-list-item pdl-50">
                        <span class="mdc-list-item__ripple"></span>
                        <span
                          class="mdc-list-item__text t-body2 font-m t-color-bodyGrayA t-color-bodyGrayA pdl-24"
                          >{{ $t("2039") }}</span
                        >
                      </div>
                    </router-link>
                  </div>
                  <div class="pdt-4 pdb-4">
                    <router-link
                      :class="
                        routeName[0] === 'level'
                          ? 'router-link-exact-active'
                          : ''
                      "
                      tabindex="0"
                      to="/level"
                    >
                      <div class="mdc-list-item pdl-50">
                        <span class="mdc-list-item__ripple"></span>
                        <span
                          class="mdc-list-item__text t-body2 font-m t-color-bodyGrayA t-color-bodyGrayA pdl-24"
                          >{{ $t("2040") }}</span
                        >
                      </div>
                    </router-link>
                  </div>
                  <div class="pdt-4 pdb-4">
                    <router-link
                      :class="
                        routeName[0] === 'rewardcertificatelist' ||
                        routeName[0] === 'certificatedetail'
                          ? 'router-link-exact-active'
                          : ''
                      "
                      tabindex="0"
                      to="/rewardcertificatelist"
                    >
                      <div class="mdc-list-item pdl-50">
                        <span class="mdc-list-item__ripple"></span>
                        <span
                          class="mdc-list-item__text t-body2 font-m t-color-bodyGrayA t-color-bodyGrayA pdl-24"
                          >{{ $t("2012") }}</span
                        >
                      </div>
                    </router-link>
                  </div>
                  <div class="pdt-4 pdb-4">
                    <router-link
                      :class="
                        routeName[0] === 'rewardbadgelist' ||
                        routeName[0] === 'badgedetail'
                          ? 'router-link-exact-active'
                          : ''
                      "
                      tabindex="0"
                      to="/rewardbadgelist?status=BADGE"
                    >
                      <div class="mdc-list-item pdl-50">
                        <span class="mdc-list-item__ripple"></span>
                        <span
                          class="mdc-list-item__text t-body2 font-m t-color-bodyGrayA t-color-bodyGrayA pdl-24"
                          >{{ $t("2013") }}</span
                        >
                      </div>
                    </router-link>
                  </div>
                </div>
              </div>
              <div class="pdt-4 pdb-4">
                <div
                  :class="
                    routeName[0] == 'portfolio' ||
                    routeName[0] == 'bookmarked-lesson' ||
                    routeName[0] == 'bookmarked-mission' ||
                    routeName[0] == 'liked-lesson' ||
                    routeName[0] == 'social-lesson'
                      ? 'mdc-list-item--activated'
                      : ''
                  "
                  aria-current="page"
                  class="mdc-list-item"
                >
                  <router-link tabindex="0" to="/portfolio">
                    <span class="mdc-list-item__ripple"></span>
                    <i
                      aria-hidden="true"
                      class="material-icons mdc-list-item__graphic mgl-16 mgr-36 rtl-support font-22"
                      >local_library</i
                    >
                    <span
                      class="mdc-list-item__text t-body2 font-m t-color-bodyGrayA"
                      >{{ $t("2030") }}</span
                    >
                  </router-link>

                  <button
                    aria-hidden="true"
                    class="material-icons mgl-auto mgr-16 t-color-bodyGrayA content-trigger pdx-0"
                    tabindex="0"
                    @click="submenuToggle($event)"
                  >
                    keyboard_arrow_down
                  </button>
                </div>
                <div
                  :class="
                    routeName[0] == 'portfolio' ||
                    routeName[0] == 'bookmarked-lesson' ||
                    routeName[0] == 'bookmarked-mission' ||
                    routeName[0] == 'liked-lesson' ||
                    routeName[0] == 'social-lesson'
                      ? ''
                      : 'd-none'
                  "
                  class="navDrawerSubmenu"
                >
                  <div class="pdt-4 pdb-4">
                    <router-link tabindex="0" to="/bookmarked-lesson">
                      <div class="mdc-list-item pdl-50">
                        <span class="mdc-list-item__ripple"></span>
                        <span
                          class="mdc-list-item__text t-body2 font-m t-color-bodyGrayA t-color-bodyGrayA pdl-24"
                          >{{ $t("2031") }}</span
                        >
                      </div>
                    </router-link>
                  </div>
                  <div class="pdt-4 pdb-4">
                    <router-link tabindex="0" to="/bookmarked-mission">
                      <div class="mdc-list-item pdl-50">
                        <span class="mdc-list-item__ripple"></span>
                        <span
                          class="mdc-list-item__text t-body2 font-m t-color-bodyGrayA t-color-bodyGrayA pdl-24"
                          >{{ $t("2032") }}</span
                        >
                      </div>
                    </router-link>
                  </div>
                  <div class="pdt-4 pdb-4">
                    <router-link tabindex="0" to="/liked-lesson">
                      <div class="mdc-list-item pdl-50">
                        <span class="mdc-list-item__ripple"></span>
                        <span
                          class="mdc-list-item__text t-body2 font-m t-color-bodyGrayA t-color-bodyGrayA pdl-24"
                          >{{ $t("2033") }}</span
                        >
                      </div>
                    </router-link>
                  </div>
                  <div class="pdt-4 pdb-4">
                    <router-link tabindex="0" to="/social-lesson">
                      <div class="mdc-list-item pdl-50">
                        <span class="mdc-list-item__ripple"></span>
                        <span
                          class="mdc-list-item__text t-body2 font-m t-color-bodyGrayA t-color-bodyGrayA pdl-24"
                          >{{ $t("2066") }}</span
                        >
                      </div>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>

            <!-- <div class="divider mgt-8 mgb-8"></div> -->
            <drawer-social
              :activeRouteName="activeRouteName"
              :socialActive="socialActive"
              @click="closeDrawer"
            ></drawer-social>
            <drawer-board
              :activeRouteName="activeRouteName"
              :boardActive="boardActive"
              @click="closeDrawer"
            ></drawer-board>

            <div class="divider mgt-8"></div>

            <div class="nav-group">
              <div class="pdt-4 pdb-4">
                <div
                  :class="
                    routeName[0] == 'store' ? 'mdc-list-item--activated' : ''
                  "
                  aria-current="page"
                  class="mdc-list-item"
                >
                  <router-link tabindex="0" to="/store">
                    <span class="mdc-list-item__ripple"></span>
                    <i
                      aria-hidden="true"
                      class="material-icons mdc-list-item__graphic mgl-16 mgr-36 rtl-support font-22"
                      >store</i
                    >
                    <span
                      class="mdc-list-item__text t-body2 font-m t-color-bodyGrayA"
                      >{{ $t("2068") }}</span
                    >
                  </router-link>

                  <button
                    aria-hidden="true"
                    class="material-icons mgl-auto mgr-16 t-color-bodyGrayA content-trigger pdx-0"
                    tabindex="0"
                    @click="submenuToggle($event)"
                  >
                    keyboard_arrow_down
                  </button>
                </div>
                <div
                  :class="
                    routeName[0] == 'store' || routeName[0] == 'checklist'
                      ? ''
                      : 'd-none'
                  "
                  class="navDrawerSubmenu"
                >
                  <div class="pdt-4 pdb-4">
                    <router-link tabindex="0" to="/store">
                      <div class="mdc-list-item pdl-50">
                        <span class="mdc-list-item__ripple"></span>
                        <span
                          class="mdc-list-item__text t-body2 font-m t-color-bodyGrayA t-color-bodyGrayA pdl-24"
                          >{{ $t("2069") }}</span
                        >
                      </div>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>

            <div class="divider mgt-8"></div>
            <!-- {{routeName[1]}} -->
            <div class="nav-group">
              <div class="pdt-4 pdb-4">
                <div
                  :class="
                    (routeName[0] == 'member' && routeName[1] == 'purchase') ||
                    (routeName[0] == 'member' &&
                      routeName[1] == 'refundlist') ||
                    (routeName[0] == 'member' && routeName[1] == 'orderdetail')
                      ? 'mdc-list-item--activated'
                      : ''
                  "
                  aria-current="page"
                  class="mdc-list-item"
                >
                  <router-link tabindex="0" to="/member/purchase">
                    <span class="mdc-list-item__ripple"></span>
                    <i
                      aria-hidden="true"
                      class="material-icons mdc-list-item__graphic mgl-16 mgr-36 rtl-support font-22"
                      >shopping_cart</i
                    >
                    <span
                      class="mdc-list-item__text t-body2 font-m t-color-bodyGrayA"
                      >{{ $t("2041") }}</span
                    >
                  </router-link>

                  <button
                    aria-hidden="true"
                    class="material-icons mgl-auto mgr-16 t-color-bodyGrayA content-trigger pdx-0"
                    tabindex="0"
                    @click="submenuToggle($event)"
                  >
                    keyboard_arrow_down
                  </button>
                </div>
                <!-- {{routeName[1]}} -->
                <div
                  :class="
                    (routeName.length > 1 &&
                      routeName[0] == 'member' &&
                      routeName[1] == 'purchase') ||
                    (routeName.length > 1 &&
                      routeName[0] == 'member' &&
                      routeName[1] == 'orderdetail') ||
                    (routeName.length > 1 &&
                      routeName[0] == 'member' &&
                      routeName[1] == 'refundlist')
                      ? ''
                      : 'd-none'
                  "
                  class="navDrawerSubmenu"
                >
                  <div class="pdt-4 pdb-4">
                    <a
                      :class="
                        routeName[1] == 'purchase' ||
                        routeName[1] == 'orderdetail'
                          ? 'router-link-exact-active router-link-active'
                          : ''
                      "
                      href="javascript:void(0)"
                      tabindex="0"
                      @click="checkPurchase"
                    >
                      <!-- <router-link tabindex="0" v-if="(routeName[0] == 'member' && routeName[1] == 'purchase') || (routeName[0] == 'member' && routeName[1] == 'orderdetail')" to="/member/purchase"> -->
                      <div class="mdc-list-item pdl-50">
                        <span class="mdc-list-item__ripple"></span>
                        <span
                          class="mdc-list-item__text t-body2 font-m t-color-bodyGrayA t-color-bodyGrayA pdl-24"
                          >{{ $t("2042") }}</span
                        >
                      </div>
                      <!-- </router-link> -->
                    </a>
                  </div>
                  <div class="pdt-4 pdb-4">
                    <a
                      :class="
                        routeName[1] == 'refundlist'
                          ? 'router-link-exact-active router-link-active'
                          : ''
                      "
                      href="javascript:void(0)"
                      tabindex="0"
                      @click="checkRefundPurchase"
                    >
                      <div class="mdc-list-item pdl-50">
                        <span class="mdc-list-item__ripple"></span>
                        <span
                          class="mdc-list-item__text t-body2 font-m t-color-bodyGrayA t-color-bodyGrayA pdl-24"
                          >{{ $t("2043") }}</span
                        >
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div class="nav-group">
              <div class="pdt-4 pdb-4">
                <div
                  :class="
                    (routeName.length > 1 &&
                      routeName[0] == 'member' &&
                      routeName[1] == 'myinfo') ||
                    (routeName.length > 1 &&
                      routeName[0] == 'member' &&
                      routeName[1] == 'memberdetail') ||
                    (routeName.length > 1 &&
                      routeName[0] == 'member' &&
                      routeName[1] == 'myphone') ||
                    (routeName.length > 1 &&
                      routeName[0] == 'member' &&
                      routeName[1] == 'memberDOB') ||
                    (routeName.length > 1 &&
                      routeName[0] == 'member' &&
                      routeName[1] == 'myinfochangepassword') ||
                    routeName[0] == 'license' ||
                    routeName[0] == 'viewLicense' ||
                    routeName[0] == 'report' ||
                    routeName[0] == 'reportdetail'
                      ? 'mdc-list-item--activated'
                      : ''
                  "
                  aria-current="page"
                  class="mdc-list-item"
                >
                  <router-link tabindex="0" to="/member/myinfo">
                    <span class="mdc-list-item__ripple"></span>
                    <i
                      aria-hidden="true"
                      class="material-icons mdc-list-item__graphic mgl-16 mgr-36 rtl-support font-22"
                      >person</i
                    >
                    <span
                      class="mdc-list-item__text t-body2 font-m t-color-bodyGrayA"
                      >{{ $t("2044") }}</span
                    >
                  </router-link>
                  <button
                    aria-hidden="true"
                    class="material-icons mgl-auto mgr-16 t-color-bodyGrayA content-trigger pdx-0"
                    tabindex="0"
                    @click="submenuToggle($event)"
                  >
                    keyboard_arrow_down
                  </button>
                </div>
                <div
                  :class="
                    (routeName.length > 1 &&
                      routeName[0] == 'member' &&
                      routeName[1] == 'myinfo') ||
                    (routeName.length > 1 &&
                      routeName[0] == 'member' &&
                      routeName[1] == 'memberdetail') ||
                    (routeName.length > 1 &&
                      routeName[0] == 'member' &&
                      routeName[1] == 'myphone') ||
                    (routeName.length > 1 &&
                      routeName[0] == 'member' &&
                      routeName[1] == 'memberDOB') ||
                    (routeName.length > 1 &&
                      routeName[0] == 'member' &&
                      routeName[1] == 'myinfochangepassword') ||
                    routeName[0] == 'license' ||
                    routeName[0] == 'viewLicense' ||
                    routeName[0] == 'report' ||
                    routeName[0] == 'reportdetail'
                      ? ''
                      : 'd-none'
                  "
                  class="navDrawerSubmenu"
                >
                  <div class="pdt-4 pdb-4">
                    <a
                      :class="
                        routeName[0] == 'viewLicense' ||
                        routeName[0] == 'license'
                          ? 'router-link-exact-active router-link-active'
                          : ''
                      "
                      href="javascript:void(0)"
                      tabindex="0"
                      @click="checkLiencese"
                    >
                      <div class="mdc-list-item pdl-50">
                        <span class="mdc-list-item__ripple"></span>
                        <span
                          class="mdc-list-item__text t-body2 font-m t-color-bodyGrayA t-color-bodyGrayA pdl-24"
                          >{{ $t("2046") }}</span
                        >
                      </div>
                    </a>
                  </div>
                  <div class="pdt-4 pdb-4">
                    <router-link
                      :class="
                        routeName[0] == 'reportdetail'
                          ? 'router-link-exact-active'
                          : ''
                      "
                      tabindex="0"
                      to="/report"
                    >
                      <div class="mdc-list-item pdl-50">
                        <span class="mdc-list-item__ripple"></span>
                        <span
                          class="mdc-list-item__text t-body2 font-m t-color-bodyGrayA t-color-bodyGrayA pdl-24"
                          >{{ $t("2047") }}</span
                        >
                      </div>
                    </router-link>
                  </div>
                  <div class="pdt-4 pdb-4">
                    <router-link
                      :class="
                        (routeName.length > 1 &&
                          routeName[0] == 'member' &&
                          routeName[1] == 'myphone') ||
                        (routeName.length > 1 &&
                          routeName[0] == 'member' &&
                          routeName[1] == 'memberDOB')
                          ? 'router-link-exact-active'
                          : ''
                      "
                      tabindex="0"
                      to="/member/memberdetail"
                    >
                      <div class="mdc-list-item pdl-50">
                        <span class="mdc-list-item__ripple"></span>
                        <span
                          class="mdc-list-item__text t-body2 font-m t-color-bodyGrayA t-color-bodyGrayA pdl-24"
                          >{{ $t("2048") }}</span
                        >
                      </div>
                    </router-link>
                  </div>
                  <div class="pdt-4 pdb-4">
                    <router-link tabindex="0" to="/member/myinfochangepassword">
                      <div class="mdc-list-item pdl-50">
                        <span class="mdc-list-item__ripple"></span>
                        <span
                          class="mdc-list-item__text t-body2 font-m t-color-bodyGrayA t-color-bodyGrayA pdl-24"
                          >{{ $t("2049") }}</span
                        >
                      </div>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="isIdpService" class="divider mgt-8"></div>
            <div v-if="isIdpService" class="nav-group">
              <div class="pdt-4 pdb-4">
                <a
                  aria-current="page"
                  class="mdc-list-item bg-white"
                  tabindex="0"
                  :href="serviceLinkObj.udemyUrl"
                  target="_blank"
                >
                  <span class="mdc-list-item__ripple"></span>
                  <i
                    aria-hidden="true"
                    class="material-icons mdc-list-item__graphic mgl-16 mgr-36 rtl-support font-22"
                    >sync</i
                  >
                  <span
                    class="mdc-list-item__text t-body2 font-m t-color-bodyGrayA"
                    >{{ $t("3901") }}</span
                  >
                </a>
              </div>
              <div class="pdt-4 pdb-4">
                <a
                  aria-current="page"
                  class="mdc-list-item bg-white"
                  tabindex="0"
                  :href="serviceLinkObj.judgeUrl"
                  target="_blank"
                >
                  <span class="mdc-list-item__ripple"></span>
                  <i
                    aria-hidden="true"
                    class="material-icons mdc-list-item__graphic mgl-16 mgr-36 rtl-support font-22"
                    >sync</i
                  >
                  <span
                    class="mdc-list-item__text t-body2 font-m t-color-bodyGrayA"
                    >{{ $t("3902") }}</span
                  >
                </a>
              </div>
              <div class="pdt-4 pdb-4">
                <a
                  aria-current="page"
                  class="mdc-list-item bg-white"
                  tabindex="0"
                  :href="serviceLinkObj.reviewBoardUrl"
                  target="_blank"
                >
                  <span class="mdc-list-item__ripple"></span>
                  <i
                    aria-hidden="true"
                    class="material-icons mdc-list-item__graphic mgl-16 mgr-36 rtl-support font-22"
                    >sync</i
                  >
                  <span
                    class="mdc-list-item__text t-body2 font-m t-color-bodyGrayA"
                    >{{ $t("3903") }}</span
                  >
                </a>
              </div>
              
            </div>

            <div class="divider mgt-8" v-if="isIdpService"></div>
            <div class="nav-group">
              <div class="pdt-4 pdb-4">
                <router-link
                  :class="
                    routeName[0] == 'setting' ? 'mdc-list-item--activated' : ''
                  "
                  aria-current="page"
                  class="mdc-list-item bg-white"
                  tabindex="0"
                  to="/setting"
                >
                  <span class="mdc-list-item__ripple"></span>
                  <i
                    aria-hidden="true"
                    class="material-icons mdc-list-item__graphic mgl-16 mgr-36 rtl-support font-22"
                    >settings</i
                  >

                  <span
                    class="mdc-list-item__text t-body2 font-m t-color-bodyGrayA"
                    >{{ $t("2050") }}</span
                  >

                  <!-- <i class="material-icons mgl-auto mgr-16 t-color-bodyGrayA content-trigger pdx-0" tabindex="0"  @click="submenuToggle($event)"
                                      aria-hidden="true">keyboard_arrow_down</i> -->
                </router-link>
              </div>
            </div>
            <div class="divider mgt-8"></div>

            <div class="nav-group">
              <div class="pdt-4 pdb-4">
                <div
                  aria-current="page"
                  class="mdc-list-item"
                  tabindex="0"
                  @click="logout"
                >
                  <span class="mdc-list-item__ripple"></span>
                  <i
                    aria-hidden="true"
                    class="material-icons mdc-list-item__graphic mgl-16 mgr-36 rtl-support font-22"
                    >logout</i
                  >
                  <span
                    class="mdc-list-item__text t-body2 font-m t-color-bodyGrayA"
                    >{{ $t("2064") }}</span
                  >
                </div>
              </div>
            </div>

            <div class="divider mgt-8"></div>

            <div class="nav-group">
              <div class="pdt-4 pdb-4">
                <div aria-current="page" class="mdc-list-item">
                  <span class="mdc-list-item__ripple"></span>
                  <i
                    aria-hidden="true"
                    class="material-icons mdc-list-item__graphic mgl-16 mgr-36 rtl-support font-22"
                    >history</i
                  >
                  <div class="">
                    <div class="mdc-list-item__text t-body2 font-m">
                      {{ $t("2063") }}
                    </div>
                    <div class="d-flex align-items-baseline mgt-5">
                      <span
                        class="mdc-list-item__text t-body3 t-color-bodyGrayB font-r"
                        >{{
                          lastLogin ? $moment(lastLogin).format("L") : ""
                        }}</span
                      >
                      &nbsp;<span
                        class="mdc-list-item__text t-body3 t-color-bodyGrayB font-r"
                      >
                        {{
                          lastLogin ? $moment(lastLogin).format("HH:mm") : ""
                        }}</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="divider mgt-8 mgb-8"></div>

					<div class="pdt-4 pdb-4">
						<a
							class="mdc-list-item  align-items-start"
							href="#"
							aria-current="page"
						>
							<span class="mdc-list-item__ripple"></span>
							<i class="material-icons mdc-list-item__graphic mgl-16 mgr-36 rtl-support font-22"
								aria-hidden="true">
								history
							</i>
							<div>
								<div class="mdc-list-item__text t-body2 font-m t-color-bodyGrayA">{{ $t("2063") }}</div>
								<div class="mdc-list-item__text t-body3 t-bodyGrayB">
									최근 2020.04.07 13:56
								</div>
							</div>
						</a>
					</div> -->
          </nav>
        </div>
      </div>
    </aside>
    <div class="mdc-drawer-scrim transition"></div>
  </div>
</template>

<script>
/**
 * 네비게이션 드로워 회원 컴포넌트(navigation drawer member Components)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import loginApi from "@/api/loginApi.js";
import memberApi from "@/api/memberApi.js";
import TopAppBarDrawerLanguage from "./TopAppBarDrawerLanguage.vue";
import TopAppBarDrawerLectureList from "./TopAppBarDrawerLectureList.vue";
import TopAppBarDrawerSocial from "./TopAppBarDrawerSocial.vue";
import TopAppBarDrawerBoard from "./TopAppBarDrawerBoard.vue";
import { mapState } from "vuex";
import licenseApi from "@/api/licenseApi.js";
import { storageConstants } from "@/utils/enum/StorageConstants";
import localStorageUtil from "@/utils/localStorageUtil";

export default {
  props: ["isDrawerOpen"],

  components: {
    "drawer-language": TopAppBarDrawerLanguage,
    "drawer-lecture-list": TopAppBarDrawerLectureList,
    "drawer-social": TopAppBarDrawerSocial,
    "drawer-board": TopAppBarDrawerBoard,
    UserImgProfile: () => import("@/components/common/checkUser/UserImgProfile.vue"),
  },

  data() {
    return {
      // token: localStorage.getItem('token'),
      routeIndex: 0,
      activeRouteName: "",
      memberImageUrl: "",
      memberName: "",
      firstName: null,
      lastName: null,
      memberDutyName: "",
      memberDutyRoleName: "",
      memberResponsibilityName: "",
      socialLearningBoard: "",
      currentPage: false,
      pathSigment: [],
      routeName: this.$route.path.split("/").slice(1),
      routeQuery: [],
      socialActive: "",
      boardActive: "",
      memberId: "",
      firstCharOfNames: localStorage.getItem("firstChar"),
      bgColorOfName: localStorage.getItem("bgColors"),
      lastLogin: "",
      materialUiInterval: null,
      isMicro: "",
      isSkillPath: localStorageUtil.isSkillPath(),
      isIdpService: localStorageUtil.isIdpServiceValidate(),
      serviceLinkObj: JSON.parse(
        localStorage.getItem(storageConstants.idpServiceUrl)
      ),
      signOutUrl: localStorage.getItem(storageConstants.idpSignOutUrl),
    };
  },
  computed: {
    ...mapState({
      memberDetail: (state) => state.member.memberDetail,
    }),

    isLearnView() {
      return (
        this.routeName[0] === "learn" &&
        (this.routeQuery.status === "LEARNING" ||
          this.routeQuery.status === "WAITING" ||
          this.routeQuery.status === "COMPLETION")
      );
    },

    isMicroView() {
      return (
        this.routeName[0] === "micro" &&
        (this.routeQuery.status === "LEARNING" ||
          this.routeQuery.status === "WAITING" ||
          this.routeQuery.status === "COMPLETION")
      );
    },
  },

  watch: {
    route($route) {
      this.navigationDrawerHandler();
    },
  },

  mounted() {
    this.isMicro = this.routeName[0] === "micro";
    this.getMemberDetails();
    window.mdc.autoInit();
    this.materialUiInterval = setInterval(
      function () {
        this.navigationDrawerHandler();
      }.bind(this),
      100
    );
  },

  methods: {
    navigationDrawerHandler() {
      const drawerToggle = document.querySelector(".navToggle");
      const drawer = document.querySelector(".mdc-drawer");
      const backDrop = document.querySelector(".mdc-drawer-scrim");

      if (drawerToggle === null) {
        return;
      }

      drawerToggle.addEventListener("click", () => {
        drawer.classList.toggle("mobilehide");
        backDrop.classList.add("d-block");
      });
      backDrop.addEventListener("click", () => {
        drawer.classList.toggle("mobilehide");
        backDrop.classList.remove("d-block");
      });

      window.addEventListener("load", modalToggle());
      window.addEventListener("resize", modalToggle());

      drawerToggle.addEventListener("click", () => {
        drawer.style.transform = "translateX(0)";
        drawer.classList.add("transition");
        backDrop.classList.add("d-block");
        drawer.classList.remove("mobilehide");
      });
      backDrop.addEventListener("click", () => {
        // alert('hi;;;')
        drawer.style.transform = "translateX(0)";

        let html = document.documentElement; // returns the html tag
        let selectedDir = html.getAttribute("dir");
        // console.log(html.getAttribute("dir"))
        if (selectedDir === "ltr") {
          drawer.style.transform = "translateX(-403px)";
        } else {
          drawer.style.transform = "translateX(404px)";
        }
        drawer.classList.remove("d-block");
        backDrop.classList.remove("d-block");
      });

      this.routeQuery = this.$route.query;
      //let pathName = routeName[1];

      function modalToggle() {
        let html = document.documentElement; // returns the html tag
        let selectedDir = html.getAttribute("dir");
        // console.log(html.getAttribute("dir"))
        if (window.innerWidth < 1920) {
          document
            .querySelector(".mdc-drawer")
            .classList.add("mdc-drawer--modal2");
        } else {
          document
            .querySelector(".mdc-drawer")
            .classList.remove("mdc-drawer--modal2");
        }
        if (window.innerWidth >= 1920) {
          drawer.style.transform = "translateX(0)";
          backDrop.classList.remove("d-block");
        } else {
          if (selectedDir === "ltr") {
            drawer.style.transform = "translateX(-401px)";
          } else {
            drawer.style.transform = "translateX(402px)";
          }
        }
      }
      clearInterval(this.materialUiInterval);
    },

    getMemberDetails() {
      memberApi.getMemberInfo().then((response) => {
        let responseData = response.data.data;
        this.memberImageUrl = responseData.profile;
        this.memberName = responseData.name.fullName;
        this.firstName = responseData.name.first;
        this.lastName = responseData.name.last;
        this.memberDutyName = responseData.dutyName;
        this.memberDutyRoleName = responseData.dutyRole.text;
        this.memberResponsibilityName = responseData.responsibilityName;
        this.memberId = responseData.id;
        this.lastLogin = responseData.lastLoginTime;
        localStorage.setItem(storageConstants.memberName, this.memberName);
        localStorage.setItem(storageConstants.memberId, this.memberId);
        //this.SET_MEMBER_DETAIL(responseData);
      });
    },

    checkLiencese() {
      let params = {
        memberId: this.memberId,
      };
      licenseApi
        .getLicenseResponsibility(params)
        .then((response) => {
          if (response.data.data.type.translate == "NONE") {
            this.$alert({
              title: "",
              content: this.$t("3094"),
              accept: this.$t("3095"),
            })
              .then(() => {})
              .catch(() => {});
          } else {
            this.$router.push({
              name: "License",
            });
          }
        })
        .then((error) => {
          console.log(error);
        });
    },

    checkPurchase() {
      this.$router.push({
        name: "MemberPurchase",
      });
    },

    checkRefundPurchase() {
      this.$router.push({
        name: "MemberPurchaseRefundList",
      });
    },

    submenuToggle(evt) {
      var testarray = document.getElementsByClassName("navDrawerSubmenu");
      let closeSubmenu = evt.target.parentNode.nextElementSibling.className
        .split(/\s+/)
        .find((val) => val == "d-none");
      for (var i = 0; i < testarray.length; i++) {
        testarray[i].className += " d-none";
        testarray[i].previousSibling.lastElementChild.innerHTML =
          "keyboard_arrow_down";
      }
      if (closeSubmenu) {
        evt.target.parentNode.nextElementSibling.classList.toggle("d-none");
        evt.target.innerHTML = "keyboard_arrow_up";
      }
    },
    // 프로필 설정 메뉴 오픈(open profile menu)
    openPattenDialog() {
      this.$emit("openPattenDialog");
    },

    closeDrawer() {
      this.$emit("closeDrawer");
    },

    getProfilePicture(path) {
      this.$emit("closePattenDialog");
      this.$router.push(path);
    },

    // 로그아웃(logout)
		logout() {
      if(this.isIdpService) {
	      localStorageUtil.init();
        this.$moveIdpLogout();
      } else {
        loginApi
            .logout()
            .then((response) => {
              localStorageUtil.init();
              this.$router.push("/");
            }).catch(() => {
          localStorageUtil.init();
          this.$router.push("/");
        });
      }
		},

    showAlert() {
      this.$alert({
        // title: this.$t('72'),
        content: this.$t("73"),
        accept: this.$t("74"),
      });
    },
  },
};
</script>
<style scoped></style>
